import { TsrctNegotiatedQuote, TsrctQuoteOrNegotiatedQuote } from '@/generated/gql/graphql';

import { DeepPartialWithNull } from './DeepPartial';

export const isNegotiatedQuote = (
  quote: DeepPartialWithNull<TsrctQuoteOrNegotiatedQuote>,
): quote is TsrctNegotiatedQuote => quote?.__typename === 'TsrctNegotiatedQuote';
